/** Shared page component copy. EN mirrors SV until proper translations are added. */
export const componentsTranslationsSv = {
    pressReleasesFilter: {
        contentType: {
            all: 'Visa allt',
            analyzeAndIr: 'Analys & IR',
            pressReleases: 'Pressmeddelanden',
            reports: 'Rapporter',
            relatedTransactions: 'Transaktioner',
        },
        labels: {
            content: 'Innehåll',
            endDate: 'Tidsperiod slut',
            pointInTime: 'Tidpunkt',
            freeTextSearch: 'Fritextsökning',
            twoSelected: '2 valda',
        },
    },
    underwritersTable: {
        subscriptionWithoutRights: 'TÅ utan rätter',
        totalInCurrency: 'Totalt ({{currency}})',
        totalPercent: 'Totalt i %',
        compensationLevel: 'Ersättningsnivå',
        amountDisclaimer: 'Fullständig information angående belopp per deltagare har ej kommunicerats av bolaget.',
    },
    dropdownSelect: {
        oneSelected: '1 vald',
        selectedCount: '{{count}} valda',
    },
    issueWarrantSummary: {
        summary: 'Sammanfattning',
        secured: 'Säkrad:',
        outcome: 'Utfall:',
        open: 'Öppna {{type}}',
    },
    autocomplete: {
        noResults: 'Inga träffar',
        groups: {
            issues: 'Emissioner',
            warrants: 'Optioner',
            companies: 'Bolag',
            investors: 'Investerare',
            convertibles: 'Konvertibler',
            searchHistory: 'Senaste sökningar',
        },
    },
    customColumnsPanel: {
        reset: 'Återställ',
    },
    customDataGridToolbar: {
        customizeColumns: 'Anpassa kolumner',
    },
    investorNameCell: {
        unnamed: 'Ej namngiven',
    },
    utils: {
        getFeeDescription: {
            cash: 'kontant',
            and: 'och',
            or: 'eller',
            inSharesUnits: 'i aktier/units.',
        },
    },
    sourceTypes: {
        cancellation: 'Avbruten',
        update: 'Uppdatering',
        stabilisation: 'Stabilisering',
        newCommitments: 'Nya åtaganden',
        outcome: 'Utfall',
        publication: 'Offentliggörande',
        publicationWarrant: 'Ursprung',
        terms: 'Villkor',
        informationDocument: 'Informationsdokument',
        prospectus: 'Prospekt',
        memorandum: 'Memorandum',
        supplement: 'Tillägg',
        conversion: 'Konvertering',
        offset: 'Kvittning',
        repayment: 'Återbetalning',
    },
}
